$(document).on("change input", ".js-counter", function () {
  if (this.value.match(/[^0-9]/g)) {
    this.value = Number(this.value.replace(/[^0-9]/g, ""));
  }

  this.value = Number(this.value);

  if (this.value == 0) {
    this.value = 1;
  }

  return false;
});

$(document).on("click", ".js-counterPlus", function () {
  const parent = $(this).parent();
  const counter = parent.find(".js-counter");
  const counterCurrent = Number(counter.val());

  counter.val(counterCurrent + 1);
  counter.change();
});

$(document).on("click", ".js-counterMinus", function () {
  const parent = $(this).parent();
  const counter = parent.find(".js-counter");
  const counterCurrent = Number(counter.val());

  if (counterCurrent > 1) {
    counter.val(counterCurrent - 1);
    counter.change();
  }
});
